export const removeDuplicates = (arr, key) => {
    const uniqueKeys = new Set();
    return arr?.filter?.((obj) => {
        const keyValue = obj[key];
        if (!uniqueKeys.has(keyValue)) {
            uniqueKeys.add(keyValue);
            return true;
        }
        return false;
    });
};
